
import React from 'react';

function TestimonialsSection() {
  const testimonials = [
    {
      name: "Suresh, Thudiyalur",
      image: "/hellotruck-web-images/author-1.jpg",
      text: "Hello Truck helped us with our office relocation last month. The service was prompt and efficient. The team was careful with our equipment and furniture. The only minor issue was a slight delay in arrival time, but they made up for it with fast service."
    },
    {
      name: "Kannan, Peelamedu",
      image: "/hellotruck-web-images/author-2.jpg",
      text: "As a business owner, reliable transportation is crucial for my operations. Hello Truck has been our logistics partner for over 2 years now. Their consistent service, transparent pricing, and responsive customer support make them stand out from other providers in Coimbatore."
    },
    {
      name: "Ganesan, Singanallur",
      image: "/hellotruck-web-images/author-1.jpg",
      text: "I recently used Hello Truck for my house shifting from Coimbatore to Tiruppur, and I couldn't be happier! The team was professional, and they handled all my belongings with care. Highly recommend their services!"
    }
  ];

  return (
    <div className="our-testimonials">
      <div className="container">
        <div className="row section-row">
          <div className="col-lg-12">
            <div className="section-title section-title-center">
              <h3 className="wow fadeInUp">testimonials</h3>
              <h2 className="text-anime-style-2" data-cursor="-opaque">Words of appreciation from <span>our customers</span></h2>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12">
            <div className="testimonial-slider">
              <div className="swiper">
                <div className="swiper-wrapper" data-cursor-text="Drag">
                  {testimonials.map((testimonial, index) => (
                    <div key={index} className="swiper-slide">
                      <div className="testimonial-item">
                        <div className="author-image">
                          <figure className="image-anime">
                            <img src={testimonial.image} alt="Customer testimonial" loading="lazy" width="80" height="80" />
                          </figure>
                        </div>

                        <div className="author-content">
                          <div className="author-title">
                            <h3>{testimonial.name}</h3>
                          </div>
                          <div className="author-rating">
                            <i className="fa-solid fa-star"></i>
                            <i className="fa-solid fa-star"></i>
                            <i className="fa-solid fa-star"></i>
                            <i className="fa-solid fa-star"></i>
                            <i className="fa-solid fa-star"></i>
                          </div>
                        </div>

                        <div className="testimonial-content">
                          <p>{testimonial.text}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="testimonial-btn">
                  <div className="testimonial-btn-prev"></div>
                  <div className="testimonial-btn-next"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TestimonialsSection;
